import 'swiper/css';
import './styles/main.scss';

import './scripts/menu.js'
import './scripts/sliders.js';
import './scripts/map.js';
import './scripts/sidebar.js';
import './scripts/product-tabs';
